import { Dispatch, FC, SetStateAction, useState } from 'react';
import { Hr } from 'src/components/_commons';
import { millisecondsOneDay } from '@monorepo/helpers';
import { NotificationsMeetingAssignments } from './commons/NotificationsMeetingAssignments';
import { NotificationsSettings } from './commons/NotificationsSettings';
import { NotificationsTitle } from './commons/NotificationsTitle';
import { typeNotificationsDoc, typeMeetingsDoc, typeNotificationSetting, typeUser } from '@monorepo/models';

type propsType = {
    meetingsDoc: typeMeetingsDoc;
    notificationsDoc: typeNotificationsDoc;
    setRefreshCounter: Dispatch<SetStateAction<number>>;
    users: typeUser[];
};

export const NotificationsMeetingsMidweekAssignments: FC<propsType> = ({
    meetingsDoc, notificationsDoc, setRefreshCounter, users
}) => {
    const [head1Id, setHead1Id] = useState<number | null | undefined>(notificationsDoc.midweekHeadOfDepartmentId);
    const [newNotificationSettings, setNewNotificationSettings] = useState<typeNotificationSetting[]>(notificationsDoc.midweek);
    const meetings = meetingsDoc.midweeks
        .filter(m => new Date(m.date).getTime() > new Date().getTime() - millisecondsOneDay)
        .filter(m => m.sections.some(s => s.segments.some(se => se.assignments.some(a => a.user))))
    ;
    const type = 'meetings-midweek-assignment';

    return (
        <div>
            <NotificationsTitle
                type={type}
            />
            <NotificationsSettings
                head1Id={head1Id}
                head1OriginalId={notificationsDoc.midweekHeadOfDepartmentId}
                head2Id={null}
                head2OriginalId={null}
                notificationsDoc={notificationsDoc}
                notificationSettings={notificationsDoc.midweek}
                newNotificationSettings={newNotificationSettings}
                setNewNotificationSettings={setNewNotificationSettings}
                setRefreshCounter={setRefreshCounter}
                type={type}
                updateHead1Id={setHead1Id}
                updateHead2Id={() => {}}
                users={users}
            />

            <Hr classes={'my-5'} />

            <NotificationsMeetingAssignments
                meetings={meetings}
            />
        </div>
    );
}
